import React, {useState, useEffect, useRef} from 'react'
import productMachineConfig from 'containers/purchase/machines/product_machine_config'
import {stepConfig, isLastStep, currentStep, stepStatus} from 'utils/step_utils'
import resCn from 'lib/responsive_classes'
import PriceSummary from 'components/price_summary'
import { Button, Col, Row } from 'reactstrap'

const PurchaseError = ({error}) => (
  <div id="purchase-error">
    {error &&
      <Alert color="danger">{error}</Alert>
    }
  </div>
)

const PurchaseModule = (props) => {
  const {machine, purchaseProps} = props
  const {resSize} = purchaseProps

  const [current, send] = machine
  const {error, reservation_ready, cart, redirect_url} = current.context
  const config = productMachineConfig(purchaseProps.machine, purchaseProps)
  const stepsConfig = config.steps
  const currentStepConfig = stepConfig(stepsConfig, current.value)
  const showReservationButton = !config.hideReservatioButton && isLastStep(stepsConfig, current.value)

  return (
    <div>
      <PurchaseError error={error}/>



      <Row>
        <Col
          xs="12"
          md={resSize == 'slim' ? "12" : "4"}
          className={resCn({
            wide: showReservationButton ? "offset-md-6" : "offset-md-8",
            slim: "offset-0"
          }, resSize)}
        >
          <PriceSummary machine={machine}/>
        </Col>
        {showReservationButton &&
          <Col
            xs="12"
            md={resSize == 'slim' ? "12" : "2"}
            className={resCn({
              wide: "mt-md-0",
              slim: "mt-3"
            }, resSize)}
          >
            <ReservationButton/>
          </Col>
        }
      </Row>
    </div>
  )
}

export default PurchaseModule
